import { render, staticRenderFns } from "./digital-twin-main.component.vue?vue&type=template&id=a8e5f14c&scoped=true"
import script from "./digital-twin-main.component.ts?vue&type=script&lang=ts&external"
export * from "./digital-twin-main.component.ts?vue&type=script&lang=ts&external"
import style0 from "./digital-twin-main.component.vue?vue&type=style&index=0&id=a8e5f14c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e5f14c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8e5f14c')) {
      api.createRecord('a8e5f14c', component.options)
    } else {
      api.reload('a8e5f14c', component.options)
    }
    module.hot.accept("./digital-twin-main.component.vue?vue&type=template&id=a8e5f14c&scoped=true", function () {
      api.rerender('a8e5f14c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/digital-twin/digital-twin-main/digital-twin-main.component.vue"
export default component.exports